import { createSlice } from "@reduxjs/toolkit"

export const colorSlice = createSlice({
    name: "colors",
    initialState:{
    },
    reducers:{
        addColors(state, action){
            const colorData = action.payload

            for (const color of colorData) {
                state[color.color_name] = color.color_code
            }
        }
    },
})

export const { addColors } = colorSlice.actions
export default colorSlice.reducer